export const TOOLTIP_PORTAL_ID = 'tooltip-portal';
